export enum AuctionLotStatusEnum {
    "Awaiting" = 0,
    "Open" = 1,
    "Extended" = 2,
    "Completed" = 3,
    "Unavailable" = 4,
    "Validating" = 5
}